<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Email Sent !</p>
    </header>

    <section class="modal-card-body">
      We've sent out a reset link to the email address you provided at sign in, make sure to also check your spam
      mailbox. If you still don't receive the email after 15min, you can contact us through the
      <a @click="redirectToContact">Contact</a> form or by mail at <a href="mailto:contact@costuto.com">contact@costuto.com</a>.
    </section>

    <footer class="modal-card-foot">
      <span class="card-footer-item">
        <b-button @click="$parent.close()">
          Close
        </b-button>
      </span>
    </footer>
  </div>
</template>

<script>
export default {
  methods: {
    redirectToContact () {
      this.$router.push('/contact')
      this.$parent.close()
    }
  }
}
</script>
